export default "__VITE_ASSET__DQxs2IQv__"